<template>
  <div class="favorites-list">
    <!-- <div v-if="$store.getters.getCustomerRoles.length === 0">
      <div class="card">
        <div class="card-content">Click + Button to add a favorite</div>
      </div>
    </div>-->

    <!-- customerRoles-->
    <p class="header">{{ $t("Customer Roles") }}</p>
    <div class="card" v-for="r in $store.getters.getCustomerRoles" :key="r.id">
      <div class="card-content">
        <div class="content has-text-left">
          <i class="fa fa-shopping-basket" style="margin-right: 12px" />
          <a :href="'/business_profile/' + r.business_id">{{
            r.business.name
          }}</a>
          -
          <a @click="viewRole(r)">{{ r.workflow_name }}</a>
          <div class="buttons" style="margin-top: 6px">
            <span class="button is-primary" @click="reOrder(r)">
              <i class="fa fa-redo" />&nbsp;Re-order
            </span>
            <span class="button" @click="reOrder(r)">
              <i class="fa fa-share-alt" />
              &nbsp;{{ $t("share") }}
            </span>
            <!-- <button class="button is-danger">
              <i class="fa fa-heart"></i>
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="card">
      <div class="card-content">
        <i class="button fa fa-plus is-fullwidth is-info" @click="addFavorite" />
      </div>
    </div>
    <br />-->

    <!-- </div>
      <button
        class="button is-warning"
        @click="updateRoles(true)"
        v-show="$store.getters.isLoggedIn"
      >{{ $t("profile.roles-update")}}</button>
    <br />-->
    <br />
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    favoriteTitle() {
      if (!this.role) return "Unknown role";
      if (!this.role.business) return "Unknown role";
      var r = this.role;
      this.updateData();
      return `${r.business.name} - ${r.workflow_name} - ${r.role_name}`;
    },
  },
  mounted() {},
  methods: {
    addFavorite() {
      this.$swal({
        type: "info",
        text: "Complete a transaction to add a favorite",
        showCancelButton: true,
        confirmButtonText: "Transact Now",
        cancelButtonText: "Later",
      }).then((result) => {
        if (result.value) {
          this.$router.push("/tuktuk");
          return;
        }
        console.warn(`User decided not to transact now to add a favorite`);
      });
    },
    viewRole(r) {
      this.console("view customer role", r);
      if (r.data.unit_number) alert(`Unit number ${r.data.unit_number}`);
      else alert("No unit number");
    },
    reOrder(r) {
      this.console("reorder for role", r);
      if (r.workflow_name === "Commerce") {
        this.goto(`/shop/${r.business_id}`);
        return;
      }
      this.goto(`/ride`);
      // this.$router.push(`/tuktuk?workflow_id=${r.workflow_id}`).catch((err) => { console.error("reOrder router.push error", err); });
    },
  },
};
</script>

<style scoped>
hr {
  margin: 0 0;
}
.field-name {
  margin-bottom: 0;
  line-height: 0pt;
  font-size: 0.8em;
  opacity: 0.6;
}
.card {
  box-shadow: initial;
  margin-bottom: 6px;
}
.card-content {
  padding: 12px;
}
.header {
  text-align: left;
  padding: 4px 12px;
  padding-top: 0;
  opacity: 0.6;
  font-weight: 500;
}
.dark .card {
  background-color: #1f1b2494;
  color: lightslategrey;
}
.dark hr {
  background-color: rgba(255, 255, 255, 0.15);
}
</style>